<script setup lang="ts">
import type { SubmitEventPromise } from 'vuetify';
import type { TimePickerFieldProps } from '@/components/pickerFields/TimePickerField.vue';

import { reactive, ref, toRaw } from 'vue';

import KTextField from '@/components/fields/KTextField.vue';
import DatePickerField from '@/components/pickerFields/DatePickerField.vue';
import TimePickerField from '@/components/pickerFields/TimePickerField.vue';
import useForm from '@/composables/useForm';
import { requiredValidationRule } from '@/helpers/validationRules';

export interface InitialData {
  name?: string;
  date?: string;
  time?: TimePickerFieldProps['modelValue'];
}

export interface ValidData {
  name: string;
  date?: string;
  time?: TimePickerFieldProps['modelValue'];
}

export interface Props {
  loading?: boolean;
  initialData?: InitialData;
}
const props = withDefaults(defineProps<Props>(), {
  loading: false,
  initialData: () => ({}),
});
const emit = defineEmits<{
  submit: [event: SubmitEventPromise | null | undefined, formData: ValidData];
}>();

const formData = reactive<InitialData>({});
const isValid = ref(true);

const { form, handleSubmit } = useForm(props, formData, function (event) {
  emit('submit', event, toRaw(formData) as ValidData);
});
</script>

<template>
  <v-form
    ref="form"
    v-model="isValid"
    validate-on="lazy"
    :class="$style.dashboardStopDialogForm"
    data-testid="dashboardStopDialogForm"
    @submit.prevent="handleSubmit"
  >
    <h4 :class="$style.title">The person signed this job</h4>
    <KTextField
      v-model="formData.name"
      label="Name"
      :disabled="props.loading"
      :rules="[requiredValidationRule]"
      :class="$style.field"
    />
    <div :class="$style.datetimeFieldGroup">
      <div class="w-full">
        <DatePickerField
          v-model="formData.date"
          label="Date"
          :disabled="props.loading"
          :class="$style.field"
          hide-details
        />
      </div>
      <div class="w-full">
        <TimePickerField
          v-model="formData.time"
          label="Time"
          :disabled="props.loading"
          :class="$style.field"
          hide-details
        />
      </div>
    </div>
    <input type="submit" class="hidden" :disabled="props.loading" />
  </v-form>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.dashboardStopDialogForm {
  font-size: 16px;
  line-height: 1.4;
}
  .title {
    font-weight: 500;
    margin-top: 0;
  }
  .field {
  }
  .datetimeFieldGroup {
    margin-top: 0.5rem;
    display: flex;
    width: 100%;

    & > div:first-child {
      margin-right: 12px;
    }
  }
</style>
